import { radius } from '@ardoq/design-tokens';
import {
  MODERNIZED_TIMELINE_PHASES_HEIGHT,
  TIMELINE_PHASES_HEIGHT,
  TIMELINES_ITEM_ROW_HEIGHT,
} from '../consts';
import { TimelinePhasesWithRenderingParameters } from '../../types';

const getDefaultBorderRadius = (isModernizedStyle: boolean) =>
  isModernizedStyle ? radius.r4 : '10px';

type GetPhaseBorderStyleArgs = {
  infiniteLeft: boolean;
  infiniteRight: boolean;
  isModernizedStyle: boolean;
};
const getPhaseBorderStyle = ({
  infiniteLeft,
  infiniteRight,
  isModernizedStyle,
}: GetPhaseBorderStyleArgs) => {
  const defaultBorderRadius = getDefaultBorderRadius(isModernizedStyle);

  const leftBorder = infiniteLeft ? '0px' : defaultBorderRadius;
  const rightBorder = infiniteRight ? '0px' : defaultBorderRadius;
  const borderRadius = `${leftBorder} ${rightBorder} ${rightBorder} ${leftBorder}`;
  return borderRadius;
};

const getTimelinePhaseRowPadding = (phasesHeight: number) =>
  (TIMELINES_ITEM_ROW_HEIGHT - phasesHeight) / 2;

type GetDynamicPhaseStylesArgs = GetPhaseBorderStyleArgs & {
  isModernizedStyle: boolean;
  scaledStart: number;
  scaledEnd: number;
  color: string;
};
export const getDynamicPhaseStyles = ({
  infiniteLeft,
  infiniteRight,
  isModernizedStyle,
  scaledStart,
  scaledEnd,
  color,
}: GetDynamicPhaseStylesArgs) => {
  const height = isModernizedStyle
    ? MODERNIZED_TIMELINE_PHASES_HEIGHT
    : TIMELINE_PHASES_HEIGHT;

  const top = getTimelinePhaseRowPadding(height);

  return {
    height,
    top,
    left: scaledStart,
    width: scaledEnd - scaledStart,
    backgroundColor: color,
    borderRadius: getPhaseBorderStyle({
      infiniteLeft,
      infiniteRight,
      isModernizedStyle,
    }),
  };
};

export const getRenderedItemPhases = ({
  isFieldDataCollapsed,
  collapsedPhasesRowsWithRenderingParameters,
  expandedPhasesRowsWithRenderingParameters,
}: TimelinePhasesWithRenderingParameters) =>
  isFieldDataCollapsed
    ? collapsedPhasesRowsWithRenderingParameters
    : expandedPhasesRowsWithRenderingParameters;

export const getPhasesRowsHeightForItem = (
  itemPhasesData: TimelinePhasesWithRenderingParameters
) => {
  if (!itemPhasesData) {
    return 0;
  }
  const renderedPhases = getRenderedItemPhases(itemPhasesData);
  return renderedPhases?.length
    ? renderedPhases.length * TIMELINES_ITEM_ROW_HEIGHT
    : 0;
};
